<script setup lang="ts">
</script>

<template>
  <div class="container mx-auto px-4">
    <router-view />
  </div>
</template>

<style>
  html {
    background-image: url("@/assets/images/bg-app.webp");
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
    height: 100vh;
  }
</style>
